let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gJH9A")).then(() => parcelRequire('7bAD1'));